import { ref } from 'vue';

// 创建事件总线存储容器
const eventBus = ref(new Map());

// 导出事件总线钩子
export const useEventBus = () => {
  // 监听事件
  const on = (eventName, callback) => {
    if (typeof callback === 'function') {
      eventBus.value.set(eventName, callback);
    }
  };

  // 触发事件
  const emit = (eventName, ...args) => {
    const callback = eventBus.value.get(eventName);
    if (callback) {
      callback(...args);
    }
  };

  // 移除事件监听
  const off = (eventName) => {
    eventBus.value.delete(eventName);
  };

  return { on, emit, off };
};